// @ts-nocheck
// File created by ./scripts/create-asset-map
// DO NOT MODIFY
const assetsMap = new Map();
import Coinf4ari from '../icons/assets/1INCH.png';
assetsMap.set('1INCH', Coinf4ari);
import Coinzesmv from '../icons/assets/3CRV.png';
assetsMap.set('3CRV', Coinzesmv);
import Coinl0ffp from '../icons/assets/AAVE.png';
assetsMap.set('AAVE', Coinl0ffp);
import Coinodr0z from '../icons/assets/ADA.png';
assetsMap.set('ADA', Coinodr0z);
import Coinfgdix from '../icons/assets/AERGO.png';
assetsMap.set('AERGO', Coinfgdix);
import Coinf751a from '../icons/assets/ARB.png';
assetsMap.set('ARB', Coinf751a);
import Coin0ymet from '../icons/assets/Arkis.png';
assetsMap.set('Arkis', Coin0ymet);
import Coins2upb from '../icons/assets/arkisHYPE.png';
assetsMap.set('arkisHYPE', Coins2upb);
import Coinb50jo from '../icons/assets/ARKIS_STADA_BITGO.png';
assetsMap.set('ARKIS_STADA_BITGO', Coinb50jo);
import Coinpw9u6 from '../icons/assets/ARKIS_WEETH_WITHDRAWAL_NFT.png';
assetsMap.set('ARKIS_WEETH_WITHDRAWAL_NFT', Coinpw9u6);
import Coin22gpn from '../icons/assets/ATOM.png';
assetsMap.set('ATOM', Coin22gpn);
import Coinm39hw from '../icons/assets/AVAX.png';
assetsMap.set('AVAX', Coinm39hw);
import Coin2mhmt from '../icons/assets/BAL.png';
assetsMap.set('BAL', Coin2mhmt);
import Coino1bx3 from '../icons/assets/Blink.png';
assetsMap.set('Blink', Coino1bx3);
import Coinb6lsa from '../icons/assets/BNB.png';
assetsMap.set('BNB', Coinb6lsa);
import Coindofmp from '../icons/assets/BTC.png';
assetsMap.set('BTC', Coindofmp);
import Coinnqw0p from '../icons/assets/CAKE.png';
assetsMap.set('CAKE', Coinnqw0p);
import Coinrf64l from '../icons/assets/Coinbase.png';
assetsMap.set('Coinbase', Coinrf64l);
import Coin4syko from '../icons/assets/COMP.png';
assetsMap.set('COMP', Coin4syko);
import Coins5qy2 from '../icons/assets/CRO.png';
assetsMap.set('CRO', Coins5qy2);
import Coin2qka2 from '../icons/assets/CRV.png';
assetsMap.set('CRV', Coin2qka2);
import Coin7kfzt from '../icons/assets/CRV3CRYPTO.png';
assetsMap.set('CRV3CRYPTO', Coin7kfzt);
import Coinbwx4g from '../icons/assets/crvFRAX.png';
assetsMap.set('crvFRAX', Coinbwx4g);
import Coinymwqk from '../icons/assets/crvUSDETHCRV.png';
assetsMap.set('crvUSDETHCRV', Coinymwqk);
import Coinqusal from '../icons/assets/CVX.png';
assetsMap.set('CVX', Coinqusal);
import Coinyykh8 from '../icons/assets/CVXCRV.png';
assetsMap.set('CVXCRV', Coinyykh8);
import Coin80s0e from '../icons/assets/DAI.png';
assetsMap.set('DAI', Coin80s0e);
import Coinbujbz from '../icons/assets/DFI.png';
assetsMap.set('DFI', Coinbujbz);
import Coinbbh5v from '../icons/assets/DOGE.png';
assetsMap.set('DOGE', Coinbbh5v);
import Coini3rpe from '../icons/assets/DOT.png';
assetsMap.set('DOT', Coini3rpe);
import Coinao56m from '../icons/assets/ETC.png';
assetsMap.set('ETC', Coinao56m);
import Coinvd226 from '../icons/assets/ETH.png';
assetsMap.set('ETH', Coinvd226);
import Coinctej0 from '../icons/assets/FRAX.png';
assetsMap.set('FRAX', Coinctej0);
import Coinny9tu from '../icons/assets/FXS.png';
assetsMap.set('FXS', Coinny9tu);
import Coinwfoh8 from '../icons/assets/GFI.png';
assetsMap.set('GFI', Coinwfoh8);
import Coin0z3y6 from '../icons/assets/GMX.png';
assetsMap.set('GMX', Coin0z3y6);
import Coinatlwu from '../icons/assets/HBAR.png';
assetsMap.set('HBAR', Coinatlwu);
import Coinwe4w3 from '../icons/assets/KsUSDe.png';
assetsMap.set('KsUSDe', Coinwe4w3);
import Coinaygbd from '../icons/assets/KUSDe.png';
assetsMap.set('KUSDe', Coinaygbd);
import Coinqpulz from '../icons/assets/LDO.png';
assetsMap.set('LDO', Coinqpulz);
import Coin2zhn3 from '../icons/assets/LEO.png';
assetsMap.set('LEO', Coin2zhn3);
import Coinajkxm from '../icons/assets/LQTY.png';
assetsMap.set('LQTY', Coinajkxm);
import Coin85tgr from '../icons/assets/LTC.png';
assetsMap.set('LTC', Coin85tgr);
import Coinvrxef from '../icons/assets/MATIC.png';
assetsMap.set('MATIC', Coinvrxef);
import Coint1r1m from '../icons/assets/Metamask.png';
assetsMap.set('Metamask', Coint1r1m);
import Coinhuuhj from '../icons/assets/OP.png';
assetsMap.set('OP', Coinhuuhj);
import Coin76ent from '../icons/assets/OSMO.png';
assetsMap.set('OSMO', Coin76ent);
import Coint9wcu from '../icons/assets/PENDLE.png';
assetsMap.set('PENDLE', Coint9wcu);
import Coinpjmsb from '../icons/assets/pendleLogo.png';
assetsMap.set('pendleLogo', Coinpjmsb);
import Coin6j2yo from '../icons/assets/PUMP.png';
assetsMap.set('PUMP', Coin6j2yo);
import Coindctts from '../icons/assets/pumpBTC.png';
assetsMap.set('pumpBTC', Coindctts);
import Coinssmom from '../icons/assets/RLP.png';
assetsMap.set('RLP', Coinssmom);
import Coins2o7s from '../icons/assets/RSETH.png';
assetsMap.set('RSETH', Coins2o7s);
import Coin8c6u1 from '../icons/assets/SHIB.png';
assetsMap.set('SHIB', Coin8c6u1);
import Coinpv44p from '../icons/assets/SNX.png';
assetsMap.set('SNX', Coinpv44p);
import Coinjowcf from '../icons/assets/SOL.png';
assetsMap.set('SOL', Coinjowcf);
import Cointy9d3 from '../icons/assets/SPELL.png';
assetsMap.set('SPELL', Cointy9d3);
import Coinvmpsu from '../icons/assets/steCRV.png';
assetsMap.set('steCRV', Coinvmpsu);
import Coinjm3sa from '../icons/assets/STETH.png';
assetsMap.set('STETH', Coinjm3sa);
import Coins1zq9 from '../icons/assets/STG.png';
assetsMap.set('STG', Coins1zq9);
import Coinpk5hl from '../icons/assets/SUSHI.png';
assetsMap.set('SUSHI', Coinpk5hl);
import Coin86ey7 from '../icons/assets/tETH.png';
assetsMap.set('tETH', Coin86ey7);
import Coin4opac from '../icons/assets/TRX.png';
assetsMap.set('TRX', Coin4opac);
import Coine75iv from '../icons/assets/UNI.png';
assetsMap.set('UNI', Coine75iv);
import Coinmvs6x from '../icons/assets/UNIBTC.png';
assetsMap.set('UNIBTC', Coinmvs6x);
import Coinw487s from '../icons/assets/USD.png';
assetsMap.set('USD', Coinw487s);
import Coinjsiv2 from '../icons/assets/USD0++.png';
assetsMap.set('USD0++', Coinjsiv2);
import Coin81as5 from '../icons/assets/USD0.png';
assetsMap.set('USD0', Coin81as5);
import Coinqcdxw from '../icons/assets/USD0USD0++.png';
assetsMap.set('USD0USD0++', Coinqcdxw);
import Coin8omg4 from '../icons/assets/USD3.png';
assetsMap.set('USD3', Coin8omg4);
import Coinlynuj from '../icons/assets/USDC.png';
assetsMap.set('USDC', Coinlynuj);
import Coin0f4z9 from '../icons/assets/USDT.png';
assetsMap.set('USDT', Coin0f4z9);
import Coinijh1h from '../icons/assets/USR.png';
assetsMap.set('USR', Coinijh1h);
import Coingfcl6 from '../icons/assets/USRUSDC.png';
assetsMap.set('USRUSDC', Coingfcl6);
import Coinsznbd from '../icons/assets/USUAL.png';
assetsMap.set('USUAL', Coinsznbd);
import Coin8ltws from '../icons/assets/VVS.png';
assetsMap.set('VVS', Coin8ltws);
import Coinmhhf4 from '../icons/assets/WalletConnect.png';
assetsMap.set('WalletConnect', Coinmhhf4);
import Coin4yviy from '../icons/assets/WAVES.png';
assetsMap.set('WAVES', Coin4yviy);
import Coin46dlq from '../icons/assets/WBTC.png';
assetsMap.set('WBTC', Coin46dlq);
import Coinearzc from '../icons/assets/WETH.png';
assetsMap.set('WETH', Coinearzc);
import Coinfa1km from '../icons/assets/WSTUSR.png';
assetsMap.set('WSTUSR', Coinfa1km);
import Coinsu5m1 from '../icons/assets/XLM.png';
assetsMap.set('XLM', Coinsu5m1);
import Coinrni61 from '../icons/assets/XRP.png';
assetsMap.set('XRP', Coinrni61);
import Coinomhoq from '../icons/assets/XVS.png';
assetsMap.set('XVS', Coinomhoq);
export { assetsMap };
